module.exports = __webpack_public_path__ + "static/media/placeholder.54a3fa20.jpeg";